import debug from 'debug';
import { k as position, m as _toConsumableArray, o as _objectSpread2, _ as _asyncToGenerator, h as _regeneratorRuntime, e as entryMixin, t as throttle } from './index2.js';
import 'deepmerge';
import 'axios';
import Vue from 'vue';
import { _ as __vue_normalize__ } from './normalize-component.js';
import { h as hotspotsMixin } from './hotspots.js';
import PanzoomMap from './PanzoomMap.js';

var XpImg = Vue.extend({
  name: 'XpImg',
  mixins: [hotspotsMixin],
  props: {
    src: String,
    alt: String,
    width: Number,
    height: Number,
    placeholderSrc: String
  },
  data: function data() {
    return {
      currentSrc: '',
      image: null,
      isLoading: !!this.src,
      hasError: false,
      naturalRatio: void 0,
      svgImageBoundingClientRect: null,
      xpImageBoundingClientRect: null
    };
  },
  watch: {
    src: function src() {
      this.__load();
    }
  },
  computed: {
    url: function url() {
      return this.currentSrc || this.placeholderSrc || void 0;
    },
    style: function style() {
      return {
        width: this.width,
        height: this.height
      };
    }
  },
  created: function created() {
    var _this = this;

    this.screenUnwatcher = this.$watch(function (vm) {
      return [// this.$xp.screen.orientation,
      _this.$xp.screen.width, _this.$xp.screen.height].join();
    }, /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(val) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$nextTick();

              case 2:
                setTimeout(function () {
                  _this.__updateImageBoundingRect();
                }, 0);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
  },
  methods: {
    __onLoad: function __onLoad(img) {
      this.isLoading = false;
      this.hasError = false;

      this.__computeRatio(img);

      this.__updateSrc();

      this.__updateImageBoundingRect();

      this.$emit('load', this.currentSrc);
    },
    __updateImageBoundingRect: function __updateImageBoundingRect() {
      this.xpImageBoundingClientRect = this.$el.getBoundingClientRect().toJSON();
      this.svgImageBoundingClientRect = this.$el.querySelector('svg image') ? this.$el.querySelector('svg image').getBoundingClientRect().toJSON() : null;
    },
    __onError: function __onError(err) {
      console.warn(err);
      this.isLoading = false;
      this.hasError = true;
      this.currentSrc = '';
      this.$emit('error', err);
    },
    __updateSrc: function __updateSrc() {
      if (this.image !== void 0 && this.isLoading === false) {
        var src = this.image.currentSrc || this.image.src;

        if (this.currentSrc !== src) {
          this.currentSrc = src;
        }
      }
    },
    __load: function __load() {
      var _this2 = this;

      this.hasError = false;

      if (!this.src) {
        this.isLoading = false;
        this.image = void 0;
        this.currentSrc = '';
        return;
      }

      this.isLoading = true;
      var img = new Image();
      this.image = img;
      this.$xp.http.getImageUri(this.src).then(function (data) {
        if (_this2.destroyed === true) {
          return;
        }

        img.src = data; // if we are still rendering same image

        if (_this2.image === img) {
          _this2.__onLoad(img);
        }
      }).catch(function (error) {
        // if we are still rendering same image
        if (_this2.image === img && _this2.destroyed !== true) {
          _this2.__onError(error);
        }
      });
      Object.assign(img, {
        height: this.height,
        width: this.width
      });
    },
    __hotspotClickHandler: function __hotspotClickHandler(event) {
      var coords = position(event);
      var bb = event.target.getBoundingClientRect();
      this.checkForHotspot([(coords.left - bb.left) / bb.width * 100, (coords.top - bb.top) / bb.height * 100]);
    },
    __computeRatio: function __computeRatio(img) {
      var _this3 = this;

      var naturalHeight = img.naturalHeight,
          naturalWidth = img.naturalWidth;

      if (naturalHeight || naturalWidth) {
        this.naturalRatio = naturalHeight === 0 ? 1 : naturalWidth / naturalHeight;
      } else {
        this.ratioTimer = setTimeout(function () {
          if (_this3.image === img && _this3.destroyed !== true) {
            _this3.__computeRatio(img);
          }
        }, 100);
      }
    }
  },
  render: function render(h) {
    var _this4 = this;

    if (this.width && this.height && this.hotspots.length) {
      return h('div', {
        staticClass: 'xp-img'
      }, [h('svg', {
        attrs: {
          width: '100%',
          height: '100%',
          viewBox: "0, 0, ".concat(this.width, ", ").concat(this.height),
          version: '1.1',
          'xmlns:xlink': 'http://www.w3.org/1999/xlink'
        }
      }, [h('image', {
        attrs: {
          width: this.width,
          height: this.height,
          'xlink:href': this.url
        }
      })].concat(_toConsumableArray(this.hotspots.map(function (hotspot) {
        var hotspotShapAttrs = function () {
          switch (hotspot.shape) {
            case 'rect':
              return {
                width: (hotspot.br.x - hotspot.tl.x) * _this4.width / 100,
                height: (hotspot.br.y - hotspot.tl.y) * _this4.height / 100,
                x: hotspot.tl.x * _this4.width / 100,
                y: hotspot.tl.y * _this4.height / 100
              };

            case 'circle':
              return {
                cx: hotspot.center.x * _this4.width / 100,
                cy: hotspot.center.y * _this4.height / 100,
                r: hotspot.radius * _this4.width / 100
              };

            case 'polygon':
              var coords = [];
              hotspot.points.map(function (point, index) {
                coords.push(point.x * _this4.width / 100 + ', ' + point.y * _this4.height / 100);
              });
              return {
                points: coords.join(' ')
              };
          }
        }();

        return h(hotspot.shape, {
          staticClass: 'xp-img__svg-path',
          on: {
            touchend: function touchend(e) {
              e.preventDefault();

              _this4.hotspotClicked(hotspot);
            },
            mouseup: function mouseup(e) {
              e.preventDefault();

              _this4.hotspotClicked(hotspot);
            }
          },
          attrs: Object.assign({
            role: 'link',
            'aria-label': hotspot.alt,
            tabindex: 0,
            fill: 'transparent',
            'aria-labelledby': 'title'
          }, hotspotShapAttrs)
        }, []);
      }))))].concat(_toConsumableArray(!this.isLoading ? this.htmlIconHotspots.map(function (hotspot) {
        return h('span', {
          class: "xp xp--large xp-img__hotspot-icon xp-img__hotspot-icon--".concat(hotspot.icon),
          style: {
            top: ((_this4.xpImageBoundingClientRect.height - _this4.svgImageBoundingClientRect.height) / 2 + hotspot.centerYPercent * _this4.svgImageBoundingClientRect.height) / _this4.xpImageBoundingClientRect.height * 100 + '%',
            left: ((_this4.xpImageBoundingClientRect.width - _this4.svgImageBoundingClientRect.width) / 2 + hotspot.centerXPercent * _this4.svgImageBoundingClientRect.width) / _this4.xpImageBoundingClientRect.width * 100 + '%'
          },
          attrs: {
            href: hotspot.href
          },
          on: {
            touchend: function touchend(e) {
              e.preventDefault();

              _this4.hotspotClicked(hotspot);
            },
            mouseup: function mouseup(e) {
              e.preventDefault();

              _this4.hotspotClicked(hotspot);
            }
          }
        });
      }) : [])));
    }

    return h('div', {
      class: 'xp-img',
      style: this.style
    }, [h('img', {
      staticClass: 'xp-img__image',
      attrs: {
        src: this.url
      },
      style: {
        filter: this.isLoading ? 'blur(10px)' : null
      },
      on: this.hotspots !== void 0 ? _objectSpread2({}, this.$listeners, {
        'mouseup': this.__hotspotClickHandler,
        'touchend': this.__hotspotClickHandler
      }) : this.$listeners // , 'touchend': this.__getHotspotLister(), 'mouseup': this.__getHotspotLister()}

    })]);
  },
  beforeMount: function beforeMount() {
    var _this5 = this;

    if (this.placeholderSrc !== void 0) {
      var img = new Image();
      img.src = this.placeholderSrc;

      img.onload = function () {
        _this5.__computeRatio(img);
      };
    }

    this.isLoading === true && this.__load();
  },
  beforeDestroy: function beforeDestroy() {
    this.destroyed = true;
    this.screenUnwatcher();
    this.isLoading && this.$xp.http.cancelRequest(this.src);
    this.image.src = ''; // to abort loading
  }
});

var log = debug('xpedeo-core:ImageEntry');
debug.enable(process.env.VUE_APP_DEBUG);
var script = {
  mixins: [entryMixin],
  components: {
    PanzoomMap: PanzoomMap,
    XpImg: XpImg
  },
  props: {
    mode: {
      type: String,
      default: 'image',
      validator: function validator(value) {
        if (['map', 'image'].includes(value)) {
          return true;
        } else {
          console.warn('ImageEntry: mode property can either be "map" or "image');
          return false;
        }
      }
    }
  },
  data: function data(vm) {
    return {
      isCaptionActive: false,
      isZoomDialogActive: false,
      imageWidth: vm.mode === 'map' ? vm.entryData.Image.Width : vm.$xp.content.getRequiredImageWidth(vm.entryData.Image),
      imageHeight: vm.mode === 'map' ? vm.entryData.Image.Height : Math.round(vm.imageWidth / vm.entryData.Image.Width * vm.entryData.Image.Height),
      imageUrl: null,
      zoomImageUrl: null,
      imageUrlData: null
    };
  },
  created: function created() {
    // EventHub.Bus.$on(EventHub.TYPES.RE_INIT_IMAGE_MAP, this.initImageMap)
    log("created");
    this.onAreaClick = throttle(this.onAreaClick); // this.imageWidth = this.mode === 'map' ? this.entryData.Image.Width : this.$xp.content.getRequiredImageWidth(this.entryData.Image)

    this.imageHeight = this.mode === 'map' ? this.entryData.Image.Height : Math.round(this.imageWidth / this.entryData.Image.Width * this.entryData.Image.Height);
    this.imageUrl = this.$xp.content.getImageUrl(this.entryData.Image, this.mode === 'map' ? 0 : this.imageWidth);
    this.zoomImageUrl = this.$xp.content.getImageUrl(this.entryData.Image, 0);
  },
  mounted: function mounted() {
    var _this = this;

    if (this.entryData.Json.Href && this.entryData.Json.Href.length > 0 && !this.entryData.Json.ImageMap.length) {
      this.$el.querySelector('.xp-img img').addEventListener('click', function () {
        _this.$router.push(_this.entryData.Json.Href);
      });
    }
  },
  methods: {
    onAreaClick: function onAreaClick(hotspot) {
      console.log("onAreaClick");

      if (hotspot.href.length > 0 && hotspot.href.startsWith('/page/')) {
        this.$router.push(hotspot.href);
      }

      if (hotspot.route && hotspot.route.length > 0 && hotspot.route.startsWith('/page/')) {
        this.$router.push(hotspot.route);
      }
    },
    onCaptionClick: function onCaptionClick() {
      this.isCaptionActive = !this.isCaptionActive;
    },
    onZoomDialogClick: function onZoomDialogClick() {
      var _this2 = this;

      if (!this.isZoomDialogActive) {
        this.$xp.navigation.hideNav();
        this.$xp.navigation.preventAutoHide();
        this.isZoomDialogActive = true;
        this.$xp.media.setIsImageZoomDialogActive(true);
      } else {
        this.isZoomDialogActive = false;
        this.$xp.media.setIsImageZoomDialogActive(false);
        setTimeout(function () {
          _this2.$xp.navigation.allowAutoHide();

          _this2.$xp.navigation.showNav(true);
        }, 200);
      }
    }
  },
  watch: {
    '$xp.screen.orientation': {
      handler: function () {
        var _handler = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(v) {
          var _this3 = this;

          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return this.$nextTick();

                case 2:
                  if (this.mode !== 'map') {
                    setTimeout(function () {
                      _this3.imageWidth = _this3.$xp.content.getRequiredImageWidth(_this3.entryData.Image);
                      _this3.imageHeight = Math.round(_this3.imageWidth / _this3.entryData.Image.Width * _this3.entryData.Image.Height);
                      _this3.imageUrl = _this3.$xp.content.getImageUrl(_this3.entryData.Image, _this3.imageWidth);
                    }, 1000);
                  }

                case 3:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function handler(_x) {
          return _handler.apply(this, arguments);
        }

        return handler;
      }()
    }
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      class: {
        "js-entry": true,
        "o-entry": true,
        "c-image-entry": true,
        "c-image-entry--map-mode": _vm.mode === "map"
      }
    },
    [
      _c(
        "div",
        { staticClass: "c-image-entry__view" },
        [
          _c("xp-img", {
            attrs: {
              src: _vm.imageUrl,
              width: _vm.imageWidth,
              height: _vm.imageHeight,
              hotspots: _vm.entryData.Json.ImageMap || [],
              placeholderSrc: _vm.entryData.Image.Thumb
            },
            on: { "hotspot-click": _vm.onAreaClick }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          class: {
            "c-image-entry__btns": true,
            "is-hidden": _vm.$xp.navigation.isNavHidden
          }
        },
        [
          _vm.entryData.Json.Link2FullSize
            ? _c(
                "button",
                {
                  class: {
                    "c-image-entry__zoom-btn": true,
                    "js-zoom-dialog": true
                  },
                  on: { click: _vm.onZoomDialogClick }
                },
                [_c("span", { staticClass: "xp xp-zoom-in xp--large" })]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.entryData.Json.Caption && _vm.entryData.Json.Caption.length > 0
            ? _c(
                "button",
                {
                  class: {
                    "c-image-entry__caption-btn": true,
                    "js-caption": true
                  },
                  on: { click: _vm.onCaptionClick }
                },
                [_c("span", { staticClass: "xp xp-information xp--large" })]
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _vm.entryData.Json.Caption && _vm.entryData.Json.Caption.length > 0
        ? _c(
            "div",
            {
              class: {
                "c-image-entry__caption": true,
                "js-caption": true,
                "c-image-entry__caption--overlay":
                  _vm.$xp.navigation.isFullScreen,
                "c-image-entry__caption--overlay--active": _vm.isCaptionActive
              },
              on: { click: _vm.onCaptionClick }
            },
            [_vm._v("\n    " + _vm._s(_vm.entryData.Json.Caption) + "\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.entryData.Json.Link2FullSize
        ? _c(
            "transition",
            {
              attrs: {
                "enter-active-class": "animated fadeIn",
                "leave-active-class": "animated fadeOut",
                mode: "out-in",
                duration: 200
              }
            },
            [
              _vm.isZoomDialogActive
                ? _c(
                    "div",
                    { class: { "c-image-entry__zoom-dialog": true } },
                    [
                      _c(
                        "panzoom-map",
                        {
                          attrs: {
                            height: _vm.entryData.Image.Height,
                            width: _vm.entryData.Image.Width,
                            "start-center": {
                              x: _vm.entryData.Image.Width / 2,
                              y: _vm.entryData.Image.Height / 2
                            }
                          }
                        },
                        [
                          _c("xp-img", {
                            attrs: {
                              src: _vm.zoomImageUrl,
                              hotspots: [],
                              placeholderSrc: _vm.entryData.Image.Thumb
                            },
                            on: {
                              mousedown: function($event) {
                                $event.preventDefault();
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "c-image-entry__zoom-btn",
                          on: { click: _vm.onZoomDialogClick }
                        },
                        [_c("span", { staticClass: "xp xp-close xp--large" })]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ]
          )
        : _vm._e()
    ],
    1
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = __vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
